/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { packagesCreate } from "../funcs/packagesCreate.js";
import { packagesList } from "../funcs/packagesList.js";
import { packagesListVersions } from "../funcs/packagesListVersions.js";
import { packagesPublish } from "../funcs/packagesPublish.js";
import { packagesUpdate } from "../funcs/packagesUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CreatePackageResult } from "../models/components/createpackageresult.js";
import { ListPackagesResult } from "../models/components/listpackagesresult.js";
import { ListVersionsResult } from "../models/components/listversionsresult.js";
import { PublishPackageResult } from "../models/components/publishpackageresult.js";
import {
  CreatePackageRequest,
  CreatePackageSecurity,
} from "../models/operations/createpackage.js";
import {
  ListPackagesRequest,
  ListPackagesSecurity,
} from "../models/operations/listpackages.js";
import {
  ListVersionsRequest,
  ListVersionsSecurity,
} from "../models/operations/listversions.js";
import {
  PublishRequest,
  PublishSecurity,
} from "../models/operations/publish.js";
import {
  UpdatePackageRequest,
  UpdatePackageResponse,
  UpdatePackageSecurity,
} from "../models/operations/updatepackage.js";
import { unwrapAsync } from "../types/fp.js";

export class Packages extends ClientSDK {
  /**
   * createPackage packages
   *
   * @remarks
   * Create a new package for a project.
   */
  async create(
    request: CreatePackageRequest,
    security?: CreatePackageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CreatePackageResult> {
    return unwrapAsync(packagesCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listPackages packages
   *
   * @remarks
   * List all packages for a project.
   */
  async list(
    request?: ListPackagesRequest | undefined,
    security?: ListPackagesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListPackagesResult> {
    return unwrapAsync(packagesList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listVersions packages
   *
   * @remarks
   * List published versions of a package.
   */
  async listVersions(
    request: ListVersionsRequest,
    security?: ListVersionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListVersionsResult> {
    return unwrapAsync(packagesListVersions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * publish packages
   *
   * @remarks
   * Publish a new version of a package.
   */
  async publish(
    request: PublishRequest,
    security?: PublishSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PublishPackageResult> {
    return unwrapAsync(packagesPublish(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updatePackage packages
   *
   * @remarks
   * Update package details.
   */
  async update(
    request: UpdatePackageRequest,
    security?: UpdatePackageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UpdatePackageResponse> {
    return unwrapAsync(packagesUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
